import React from 'react'
import SectionTitle from '../../components/section_title/section_title'
import './process.scss'

import processimg from '../../assets/img_liucheng.png'

import steps_a from '../../assets/steps_a.png'
import steps_b from '../../assets/steps_b.png'
import steps_c from '../../assets/steps_c.png'
import steps_d from '../../assets/steps_d.png'


function Process() {
  return <div className="process_container">
    <SectionTitle type="white" subtitle="一站式服务,3D升级仅需3个小时">奥本未来3D云服务 服务流程</SectionTitle>
    <div className="step_img_container">
      <img src={processimg}></img>
    </div>
    <div className="mobile_step_img_container">

      <div className="step_img_item">
        <img src={steps_a}></img>
        <p>提交体验信息</p>
      </div>

      <div className="step_img_item">
        <img src={steps_b}></img>
        <p>提供商品样品</p>
      </div>

      <div className="step_img_item">
        <img src={steps_c}></img>
        <p>3D效果预览</p>
      </div>

      <div className="step_img_item">
        <img src={steps_d}></img>
        <p>一键嵌入上线</p>
      </div>

    </div>
  </div>
}

export default Process